module.exports = __webpack_public_path__ + "static/media/search.55b4aff2.svg";